import React from 'react'

export default function ProgressStats() {
  return (
    <div>
        {/* import from tableau */}
        <p>placeholder text for progression stats</p>
    </div>
  )
}
